import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../../styles/Innovate.scss";

gsap.registerPlugin(ScrollTrigger);

const TEXT = "Innovate";

const Innovate: React.FC = () => {
  const sectionRef = useRef<HTMLElement | null>(null);
  const lettersRef = useRef<HTMLSpanElement[]>([]);

  useEffect(() => {
    if (!sectionRef.current) return;

    const letters = lettersRef.current;

    // Initial hidden / folded state
    gsap.set(letters, {
      opacity: 0,
      rotateX: 120,
      y: 140,
      transformOrigin: "bottom center",
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 60%",   // 🔥 mas malapit bago gumalaw
        end: "top 35%",
        scrub: true,       // buttery up & down
      },
    });

    tl.to(letters, {
      opacity: 1,
      rotateX: 0,          // unfold to flat
      y: 0,
      stagger: {
        each: 0.06,
        from: "start",
      },
      ease: "none",
    });

    return () => {
      ScrollTrigger.getAll().forEach(t => t.kill());
    };
  }, []);

  return (
    <section className="innovate-section" ref={sectionRef}>
      <div className="innovate-content">
        <h1 className="innovate-title">
          {TEXT.split("").map((char, i) => (
            <span
              key={i}
              className="innovate-letter"
              ref={(el) => {
                if (el) lettersRef.current[i] = el;
              }}
            >
              {char}
            </span>
          ))}
        </h1>

        <p className="innovate-text">
          Every generation faces a turning point — a moment when
          progress demands courage, creativity, and collaboration. In
          the life insurance profession, that moment is now.
        </p>

        <button
          className="innovate-btn"
          onClick={() => (window.location.href = "/about-us")}
        >
          <span className="inn-btn-text">2027 APLIC</span>
        </button>
      </div>
    </section>
  );
};

export default Innovate;
